import { useState } from 'react';
import { useCustomerPortalToken } from '../../hooks/requests/use-customer-portal-generate-token';
import { useDialog } from '../../hooks/use-dialog';

export function useCustomerPortalDialog(customerId: string) {
  const { isDialogOpen, handleOpen, handleClose } = useDialog();
  const { data, isLoading } = useCustomerPortalToken(customerId, { enabled: isDialogOpen });
  const [isCopied, setIsCopied] = useState(false);

  const shareableLink = data?.token ? getShareableLink(data.token) : '';

  const handleCopyToClipboard = async () => {
    if (shareableLink) {
      await navigator.clipboard.writeText(shareableLink);
      setIsCopied(true);
    }
  };

  const handleDialogClose = () => {
    setIsCopied(false);
    handleClose();
  };

  return {
    isDialogOpen,
    shareableLink,
    isCopied,
    isLoading,
    handleOpen,
    handleClose: handleDialogClose,
    handleCopyToClipboard,
  };
}

function getShareableLink(token: string) {
  const hostName = window.location.hostname;
  return `https://${hostName}/invoices/shared?token=${token}`;
}
